import './monaco-editor-hack';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { GreyCat } from '@greycat/core';

import 'monaco-editor';
import gcLangService from '@greycat/lang-monaco';

// import TestApp from './TestApp';

import 'bootswatch/dist/cyborg/bootstrap.min.css';
import 'open-iconic/font/css/open-iconic-bootstrap.min.css';
import 'react-table/react-table.css';
import './index.css';

// import TestAppStore from './TestAppStore';
import Playground from './Playground';
import PlaygroundStore from './stores/PlaygroundStore';
import CodeCellStore from './stores/CodeCellStore';

const root = document.getElementById('root')!;
const errorTimeout = setTimeout(() => {
  root.innerHTML = '<p class="alert alert-danger">Something went wrong while initializing GreyCat PlayGround. Sorry :/</p>';
}, 10000);

GreyCat.onReady(() => {
  clearTimeout(errorTimeout);

  const graph = GreyCat.newGraph();
  // register GreyCat graph types/functions to linter
  gcLangService.addTypes(JSON.parse(graph.exportTypes()));
  gcLangService.addFunctions(JSON.parse(graph.exportFunctions()));

  // initialize stores
  const pgStore = new PlaygroundStore();
  pgStore.cells.push(...[
    new CodeCellStore(graph, 'varDecl', require('raw-loader!./fixtures/varDecl/hello-world.gcl'), true),
    new CodeCellStore(graph, 'varDecl', require('raw-loader!./fixtures/varDecl/a-number.gcl')),
    new CodeCellStore(graph, 'stdout', require('raw-loader!./fixtures/stdout/print.gcl')),
    new CodeCellStore(graph, 'stdout', require('raw-loader!./fixtures/stdout/print-var.gcl')),
    new CodeCellStore(graph, 'stdout', require('raw-loader!./fixtures/stdout/print-dest.gcl')),
    new CodeCellStore(graph, 'funcDecl', require('raw-loader!./fixtures/funcDecl/hello-world.gcl')),
    new CodeCellStore(graph, 'typing', require('raw-loader!./fixtures/typing/person.gcl')),
    new CodeCellStore(graph, 'typing', require('raw-loader!./fixtures/typing/person-init.gcl')),
    new CodeCellStore(graph, 'user', '// it is your time to play :)'),
  ]);

  // render app
  ReactDOM.render(<Playground store={pgStore} />, root);
});
